<style lang="scss" scoped>
	@import "./tuijiankehu.css";
</style>
<style lang='scss'>
	#tuijiankehu {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
<template>
	<div id="tuijiankehu">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="證券帳號" class="formItem">
									<a-input v-model="params.number" placeholder="請輸入證券帳號" :allowClear="true" @change="handleClear(1)"/>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="帳號名稱" class="formItem">
									<a-input v-model="params.name" placeholder="請輸入帳號名稱" :allowClear="true" @change="handleClear(2)"/>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="邀請編號" class="formItem">
									<a-input v-model="params.inviterid" placeholder="請輸入邀請編號" :allowClear="true" @change="handleClear(3)"/>
								</a-form-model-item>
							</a-col></a-row><br>
							<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="邀請人數" class="formItem">
									<a-select v-model="params.amount" placeholder="請選擇邀請人數" @change="searchEvent">
										<a-select-option v-for="(item) in admintypeArr1" :key="item.key"
											:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="邀請時間" class="formItem">
									<a-range-picker :placeholder="['開始日期','結束日期']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }" style="display: flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<!-- <div class="tableBtnView">
				<div @click='visible_bold = true'>
					<img :src="require('../../image/adds.png')" class="btnIcon" style='width: .9rem' />
					<span style="color: rgba(184, 145, 245, 1);">添加邀請人</span>
				</div>
			</div> -->
			<div class="tableBtnView">
				<div  @click="upClick()" class='btn_list'>
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='numbertitle' >
					<div @click='addfn' style="margin-left: 1rem;">
						證券帳號 <a-icon type="plus-circle" style="color: #ffa647;font-size: .8rem;margin-right: .3rem;" />
					</div>
				</span>
				<div slot='number' slot-scope="record" >
					<div v-if='record.k' class="components-input-demo-size"><a-input placeholder=" " 
					v-model='record.number' :maxLength='7' @input="handitems(record)" /></div>
					<div v-else>{{record.number}}</div>
				</div>
				<div slot='namek' slot-scope="record">
					<a-row v-if='record.k'>
						<a-col :span='17' style='text-align: right;'><div class="components-input-demo-size"><a-input placeholder=" "  v-model='record.name'/></div></a-col>
						<a-col :span='4'>
							<img :src="require('../../image/baocun.png')" alt="" title="保存"
							style='margin-top: .2rem;' @click='savefn(record)' class="imageC">
						</a-col>
						<a-col :span='3'>
							<img :src="require('../../image/quxiao.png')" alt="" title="取消"
							style='margin-top: .2rem;' @click='handdele(record)' class="imageC">
							</a-col>
					</a-row>
					<div v-else class='warps' @click='dakaiitem(record)'>{{record.name}}</div>
				</div>
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.8rem;"></span>
				<div slot='name' slot-scope="record" v-if='!record.k'>
					<div style="justify-content: space-around;display: flex;">
						<div @click='copyText(record.url_cn)' title="點擊復制">中文連結 <img :src="require('../../image/copy.png')"
								class="btnIcon" style='width: .9rem;margin-top: -.1rem;' /></div>
						<div @click='copyText(record.url_en)' title="點擊復制">英文連結 <img :src="require('../../image/copy.png')"
								class="btnIcon" style='width: .9rem;margin-top: -.1rem;' /></div>
					</div>
				</div>
				<div slot='amount' slot-scope="record" class='warps' @click='dakaiitem(record)'>{{record.amount}}</div>
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == 1' style="color: #3bc7a1">使用中</div>
					<div v-if='record.status == 2' style="color: #ee5253">已暫停</div>
					<!-- <div v-if='record.status == "已暫停"' style="color: #000">已暫停</div> -->
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2" v-if='!record.k'>
						<!-- <div>
							<img :src="icon_pdf" class="imageC" @click='visible_bold = true;itemobj=record'>
						</div>
						<div class='popoverView'>
							<pushbtn :record='record' @child='handclose' :params='params'></pushbtn>
						</div> -->
						<div>
							<img :src="record.visible_bold !== 2?require('../../image/lea/chakan1.png'):require('../../image/lea/chakan.png')"
							class="imageb" @click='handediot(record)' >
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<textarea id="input" style="width: 0;height: 0;"></textarea>
		<handItem v-if='visible_bold' @child='handclose' :itemobj='itemobj'></handItem>
		<handhome v-if='visible_bold1' @child='handclose' :itemobj='itemobj'></handhome>
		<handcope v-if='visible_cope' @child='handclose' :itemobj='itemobj'></handcope>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
					<!-- <img @click.stop="downLoad()" src="../../image/icon_xiazai1.png"> -->
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/edios.png';
	import icon_pdf1 from '@/image/icon_gengduo.png';
	import handItem from './components/handItem'
	import handhome from './components/handhome'
	import handcope from './components/handcope'
	import pushbtn from './components/pushbtn.vue'

	export default {
		components: {
			handItem,
			handhome,
			handcope,
			exportData,
			pushbtn
		},
		data() {
			return {
				upFlag:false,
				ishandout: false,
				allurl: '',
				pdfShow: false,
				pdfBolUrl: '',
				ishandout:false,
				visible_cope:false,
				itemobj: {},
				visible_bold1: false,
				visible_bold: false,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				icon_pdf,
				icon_pdf1,
				admintypeArr: [
					{
						text: '使用中',
						value: 1
					},{
						text: '已暫停',
						value: 2
					},
				],
				admintypeArr1:[{
						text: '< 50',
						value: 1
					},{
						text: '50 - 100',
						value: 2
					},{
						text: '> 100',
						value: 3
					},],
				tzPageNum: '',
				columns: [
					// {
					// 	// title: '',
					// 	dataIndex: '',
					// 	align: 'right',
					// 	width: '5%',
					// 	slots: {
					// 		title: 'alltext'
					// 	},
					// 	// scopedSlots: {
					// 	// 	customRender: 'hot_status'
					// 	// }
					// },
					{
						// title: '',
						dataIndex: '',
						align: 'center',
						width: '11%',
						slots: {
							title: 'numbertitle'
						},
						scopedSlots: {
							customRender: 'number'
						}
					},
					{
						title: '帳號名稱',
						dataIndex: '',
						align: 'center',
						width: '14%',
						scopedSlots: {
							customRender: 'namek'
						},
					},
					{
						title: '邀請編號',
						dataIndex: 'inviterid',
						align: 'center',
						width: '10%',
					},
					{
						title: '邀請連結',
						dataIndex: '',
						align: 'center',
						width: '20%',
						scopedSlots: {
							customRender: 'name'
						}
					},
					{
						title: '邀請人數',
						dataIndex: '',
						align: 'center',
						width: '11%',
						scopedSlots: {
							customRender: 'amount'
						}
					},
					// {
					// 	title: '邀請狀態',
					// 	dataIndex: '',
					// 	align: 'center',
					// 	width: '12%',
					// 	scopedSlots: {
					// 		customRender: 'status'
					// 	}
					// },
					{
						title: '操作人',
						dataIndex: 'handler',
						align: 'center',
						width: '12%',
					},
					{
						title: '邀請時間',
						dataIndex: 'createtime',
						align: 'center',
						width: '12%',
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					number:'',
					status: '',
					name:'',
					amount:'',
					inviterid: '',
					begindate: '', //認購起始日期
					enddate: '', //認購截止日期
					timeDate: [],
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.getdata();
		},
		methods: {
			upClick(){
				this.upFlag = true
			},
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(pxfs){
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['domainnameid']){
						brr.push(this.columnsData[ev]['domainnameid'])
					}
				})
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.exportAddInvitationExcel
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
				+'&sort=' + sort
				+'&number=' + this.params.number
				+'&name=' + this.params.name
				+'&inviterid=' + this.params.inviterid
				+'&amount=' + this.params.amount
				+'&begindate=' + this.params.begindate
				+'&enddate=' + this.params.enddate
				+ '&idList=' + brr.join(',')
				window.location.href = url;
			},
			pdfEvent(pxfs){
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['domainnameid']){
						brr.push(this.columnsData[ev]['domainnameid'])
					}
				})
				let sort =  pxfs == undefined ? '' : pxfs
				let str = this.$api.pdfs; //getUnsk
				let url = this.$api.exportAddInvitationPDF
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
				+'&sort=' + sort
				+'&number=' + this.params.number
				+'&name=' + this.params.name
				+'&inviterid=' + this.params.inviterid
				+'&amount=' + this.params.amount
				+'&begindate=' + this.params.begindate
				+'&enddate=' + this.params.enddate
				+ '&idList=' + brr.join(',')
				// + '&bankidList=' + brr.join(',')
				this.allurl = str + url
				console.log(url)
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
            handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if(val == 1){
					if (!this.params.number) {
						this.getdata()
					}
				}
				if(val == 2){
					if (!this.params.name) {
						this.getdata()
					}
				}
				if(val == 3){
					if (!this.params.inviterid) {
						this.getdata()
					}
				}
			},
			// 添加证券账号
			addfn(){
				if(!this.columnsData[0].k){
					this.columnsData.unshift({k:"false"})
				}
			},
			// 打开操作弹窗
			handediot(val){
				this.visible_cope = true;
				this.itemobj = val;
			},
			handitems(val){
				val.number = val.number.replace(/[^\d]/g, '')
				// if(val.number.length==7){
				// 	val.inviterid = 'QMIS' + val.number.slice(3,7)
				// } 
			},
			// 保存
			savefn(val){
				if(val.number&&val.name){
					val.token = this.$store.state.token;
					val.flag = 'new'
					this.$ajax({
						method: 'post',
						url: this.$api.editKh,
						data: val
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							App.oTool.successT();
							this.getdata();
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
				}
			},
			handdele(val){
				let s=''
				// this.columnsData.map(e=>{
				// 	if(e==val){
				// 		s=e
				// 	}
				// })
				this.columnsData.splice(this.columnsData.indexOf(val),1)
				console.log(s)
				
			},
			dakaiitem(val) {
				this.itemobj = val
				this.visible_bold1 = true
			},
			// 复制操作
			copyText(url) {
				console.log(url)
				var input = document.getElementById("input");
				input.value = url||''; // 修改文本框的内容
				input.select(); // 选中文本
				document.execCommand("copy"); // 执行浏览器复制命令
				if (url) {
					// alert("复制成功");
					this.$message.success('復制成功')
				} else {
					clipboardData.clearData("Text")
					this.$message.warning('沒有鏈接')
				}
			},
			handopen() {
				this.$ajax({
					url: this.$api.getpdfable,
					method: 'post',
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						window.location.href = this.$api.getUn + '?token=' + this.$store.state.token + '&m=' + Date
							.parse(new Date()) +
							'&begindate=' + this.params.begindate + '&enddate=' + this.params.enddate
						// window.location.href = this.$api.getExcel+'?token=' + this.$store.state.token + '&m=' + Date.parse(new Date())
					}
				})
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.enddate = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {

					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.itemobj = {}
				this.visible_bold = false;
				this.visible_bold1 = false;			
				this.visible_cope = false;
				if (val) {
					this.getdata();
				}
			},
			// 获取页面数据
			getdata() {
				console.log(this.params)
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getKhIn,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.khInviterList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = false
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						if (this.params.number || this.params.name || this.params.inviterid || this.params.amount || this.params.begindate) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.getdata();
			},
			// 重置功能
			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					status: '',
					name:'',
					amount:'',
					number:'',
					inviterid: '',
					begindate: '', //認購起始日期
					enddate: '', //認購截止日期
					timeDate: [],
				}
				this.getdata();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getdata();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdata();
			},
		},
	};
</script>
<style lang='scss'>
	#tuijiankehu {
		.warps:hover {
			color: rgb(12, 139, 151);
			cursor: pointer;
		}
	}
</style>
